// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/* .help-container {
    margin-top: var(--space-x2-and-half);
    margin-left: var(--space-and-half);
} */

.help-container .baloa-headline-2{
    color: var(--primary-very-dark-color);
}

.league-help__left-container{
    grid-area: left;
}

.help-container__header {
    grid-area: center;
    background: var(--white-color);
    padding: 24px;
    border-top: 1px solid var(--new-gray-background-color);
    border-bottom: 1px solid var(--new-gray-background-color);
    
}

.help-message {
    padding: 24px 18px;
    background: var(--white-color);
    border-radius: 8px;
    margin: 18px 26px;
}

.help-message .hubicon-info{
    font-size: 20px;
    margin-right: 14px;
}

.help-message .hubicon-info::before{
    color: var(--new-informative-banner-color);
}

.help-options{
    display: flex;
    align-items: center;
    gap: 20px;
    justify-content: space-between;
    flex-wrap: wrap;
    margin: 0 26px;
}

.help-card {
    display: inline-flex;
    align-items: center;
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.12);
    border-radius: 8px;
    background-color: white;
    padding: calc(var(--space) + var(--space-quarter)) var(--space);
    height: 80px;
}

.help-card:hover{
    cursor: pointer; 
}

.help-info{
    margin-left: 12px;
}

.help-info .baloa-names{
    color: var(--primary-dark-color);
    font-weight: var(--font-regular);
}

.help-info__info-image{
    width: 100%;
    align-self: center;
    text-align: center;
    margin-top: 20px;
}`, "",{"version":3,"sources":["webpack://./src/app/leagues/components/help/HelpComponent.styles.css"],"names":[],"mappings":";AACA;;;GAGG;;AAEH;IACI,qCAAqC;AACzC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,8BAA8B;IAC9B,aAAa;IACb,sDAAsD;IACtD,yDAAyD;;AAE7D;;AAEA;IACI,kBAAkB;IAClB,8BAA8B;IAC9B,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,8BAA8B;IAC9B,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,2CAA2C;IAC3C,kBAAkB;IAClB,uBAAuB;IACvB,+DAA+D;IAC/D,YAAY;AAChB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gCAAgC;IAChC,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;AACpB","sourcesContent":["\r\n/* .help-container {\r\n    margin-top: var(--space-x2-and-half);\r\n    margin-left: var(--space-and-half);\r\n} */\r\n\r\n.help-container .baloa-headline-2{\r\n    color: var(--primary-very-dark-color);\r\n}\r\n\r\n.league-help__left-container{\r\n    grid-area: left;\r\n}\r\n\r\n.help-container__header {\r\n    grid-area: center;\r\n    background: var(--white-color);\r\n    padding: 24px;\r\n    border-top: 1px solid var(--new-gray-background-color);\r\n    border-bottom: 1px solid var(--new-gray-background-color);\r\n    \r\n}\r\n\r\n.help-message {\r\n    padding: 24px 18px;\r\n    background: var(--white-color);\r\n    border-radius: 8px;\r\n    margin: 18px 26px;\r\n}\r\n\r\n.help-message .hubicon-info{\r\n    font-size: 20px;\r\n    margin-right: 14px;\r\n}\r\n\r\n.help-message .hubicon-info::before{\r\n    color: var(--new-informative-banner-color);\r\n}\r\n\r\n.help-options{\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 20px;\r\n    justify-content: space-between;\r\n    flex-wrap: wrap;\r\n    margin: 0 26px;\r\n}\r\n\r\n.help-card {\r\n    display: inline-flex;\r\n    align-items: center;\r\n    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.12);\r\n    border-radius: 8px;\r\n    background-color: white;\r\n    padding: calc(var(--space) + var(--space-quarter)) var(--space);\r\n    height: 80px;\r\n}\r\n\r\n.help-card:hover{\r\n    cursor: pointer; \r\n}\r\n\r\n.help-info{\r\n    margin-left: 12px;\r\n}\r\n\r\n.help-info .baloa-names{\r\n    color: var(--primary-dark-color);\r\n    font-weight: var(--font-regular);\r\n}\r\n\r\n.help-info__info-image{\r\n    width: 100%;\r\n    align-self: center;\r\n    text-align: center;\r\n    margin-top: 20px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
